<template>
    <svg style="enable-background:new 0 0 507.2 507.2" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 507.2 507.2" version="1.1" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g class="robot-body">
        <path d="m414 173c0 141-76 290-160 290s-160-149-160-290 76-173 160-173 160 32 160 173z" fill="#0B7F9E"/>
        <path d="m254 0c83.2 0 160 32 160 173s-76 290-160 290-160-149-160-290" fill="#0B6382"/>
        <path d="m254 0c83.2 0 160 32 160 173s-76 290-160 290" fill="#00233F"/>
        <path d="m216 80c0 13.6-11.2 35.2-25.6 35.2-13.6 0-25.6-20.8-25.6-35.2 0-13.6 11.2-25.6 25.6-25.6 14 0.2 26 11.4 26 25.8z" fill="#022728"/>
        <circle cx="190" r="25.6" cy="80" fill="#00FFF2"/>
        <path d="m172 61.6c9.6-9.6 25.6-9.6 36 0 9.6 9.6 9.6 25.6 0 36" fill="#16D8D8"/>
        <circle cx="190" r="14.4" cy="80" fill="#00FFF2"/>
        <path d="m190 94.4c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4" fill="#16D8D8"/>
        <g fill="#EBFFFD">
            <circle cx="179" r="8.8" cy="68.8"/>
            <circle cx="205" r="4" cy="92.8"/>
        </g>
        <path d="m342 80c0 13.6-11.2 35.2-25.6 35.2-13.6 0-25.6-20.8-25.6-35.2 0-13.6 11.2-25.6 25.6-25.6 15 0.2 26 11.4 26 25.8z" fill="#0B6382"/>
        <circle cx="317" r="25.6" cy="80" fill="#00FFF2"/>
        <path d="m299 61.6c9.6-9.6 25.6-9.6 36 0 9.6 9.6 9.6 25.6 0 36" fill="#16D8D8"/>
        <circle cx="317" r="14.4" cy="80" fill="#00FFF2"/>
        <path d="m317 94.4c-8 0-14.4-6.4-14.4-14.4s6.4-14.4 14.4-14.4" fill="#16D8D8"/>
        <g fill="#EBFFFD">
            <circle cx="306" r="8.8" cy="68.8"/>
            <circle cx="331" r="4" cy="92.8"/>
        </g>
        <path d="m191 142l-33.6-40h-61l-1.6 16h56.8l38.4 40h56v-16h-54z" fill="#00FFF2"/>
        <polyline points="93.6 118 151 118 190 158 190 158 190 158 246 158 246 153 190 148 158 110 158 110" fill="#16D8D8"/>
        <path d="m316 142l33.6-40h61.6l1.6 16h-58l-38.4 40h-56v-16h54z" fill="#00FFF2"/>
        <polyline points="414 118 356 118 318 158 318 158 318 158 262 158 262 153 317 148 350 110 350 110" fill="#16D8D8"/>
        <circle cx="254" r="16" cy="147" fill="#00FFF2"/>
        <path d="m270 147c0 8.8-7.2 16-16 16s-16-7.2-16-16" fill="#16D8D8"/>
        <path d="m94.4 174l-0.8-1.6c0 0.8-0.8 0.8-0.8 1.6 0 93.6 32 189 80 243v-216l-29.6-27.2h-48.6z" fill="#0B7F9E"/>
        <path d="m94.4 168l-0.8 1.6c0 0.8-0.8 2.4-0.8 3.2 0 93.6 32 190 80 245v-220" fill="#00233F"/>
        <path d="m412 174l0.8-1.6c0 0.8 0.8 0.8 0.8 1.6 0 93.6-32 185-80 240v-213l29.6-27.2h48z" fill="#0B7F9E"/>
        <path d="m413 168v1.6c0 0.8 0.8 2.4 0.8 3.2 0 93.6-32 190-80 245v-220" fill="#02405B"/>
        <circle cx="50.4" r="40.8" cy="305" fill="#0B6382"/>
        <g fill="#00233F">
            <path d="m50.4 265c22.4 0 40.8 18.4 40.8 40.8s-18.4 40.8-40.8 40.8"/>
            <circle cx="50.4" r="9.6" cy="247"/>
        </g>
        <polyline points="53.6 238 53.6 198 77.6 198 77.6 166 93.6 166" fill="#16D8D8"/>
        <ellipse rx="40" transform="matrix(-.0789 -.997 .997 -.0789 -104 323)" ry="13.6" cy="210" cx="97.6" fill="#0B7F9E"/>
        <ellipse rx="24" transform="matrix(-.0788 -.997 .997 -.0788 -109 319)" ry="5.6" cy="210" cx="92.8" fill="#0B6382"/>
        <g fill="#16D8D8">
            <circle cx="127" r="3.2" cy="211"/>
            <circle cx="140" r="3.2" cy="207"/>
            <circle cx="153" r="3.2" cy="204"/>
        </g>
        <path d="m69.6 314c0 2.4-1.6 4-4 4h-32c-2.4 0-4-1.6-4-4s1.6-4 4-4h32c2.4 0 4 1 4 4z" fill="#00FFF2"/>
        
        <g class="right-arm">
            <circle cx="457" r="40.8" cy="305" fill="#0B6382"/>
            <g fill="#00233F">
                <path d="m457 265c-22.4 0-40.8 18.4-40.8 40.8s18.4 40.8 40.8 40.8"/>
                <circle cx="457" r="9.6" cy="247"/>
            </g>
            <polyline points="454 238 454 198 430 198 430 166 414 166" fill="#16D8D8"/>
            <path d="m478 314c0-2.4-1.6-4-4-4h-32c-2.4 0-4 1.6-4 4s1.6 4 4 4h32c2 0 4-2 4-4z" fill="#00FFF2"/>
        </g>
        
        <ellipse rx="40" transform="matrix(-.0789 .997 -.997 -.0789 652 -182)" ry="13.6" cy="210" cx="410" fill="#0B7F9E"/>
        <ellipse rx="24" transform="matrix(-.0788 .997 -.997 -.0788 656 -186)" ry="5.6" cy="210" cx="414" fill="#0B6382"/>
        <g fill="#16D8D8">
            <circle cx="380" r="3.2" cy="211"/>
            <circle cx="367" r="3.2" cy="207"/>
            <circle cx="354" r="3.2" cy="204"/>
        </g>
        </g>
        <!-- shadow -->
        <ellipse rx="104" ry="12" cy="495" cx="254" fill="#91C6C2"/>
        </svg>

</template>

<script>

//floating animation + dialogue for beginning and end

export default {
    props:['script'],
}

</script>

<style scoped>

svg{
    overflow: visible;
    max-width: 125px;
    height:auto;
    float:left;
    padding: 0px 15px 15px 0px;
}

.robot-body{
    animation: float 4s ease-in-out infinite;
}

.right-arm{
    transform-origin: 414px 166px;
    animation: wave 3s ease 1.75s;
}

@keyframes wave{
    0% {
		transform: rotate(0deg);
	}
    55%{
        transform: rotate(-125deg);
    }
    65%{
        transform: rotate(-140deg);
    }
    70%{
        transform: rotate(-125deg);
    }
    80%{
        transform: rotate(-140deg);
    }

	0% {
		transform: rotate(0deg);
	}
}

@keyframes float{
    0% {
		transform: translatey(15px);
	}
	50% {
		transform: translatey(-20px);
	}
	100% {
		transform: translatey(15px);
	}
}


</style>